// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text[data-v-866cb25a] {\n\tcolor: var(--main-gray-7);\n\tfont-size: 1.5em;\n\ttext-align: center;\n\tpadding: 20px;\n\tpadding-top: 10px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
